import { Flex } from 'antd';

const NoData = ({
  message = 'No Data Available',
}: {
  message?: React.ReactNode;
}) => {
  return (
    <Flex justify="center" align="center">
      <span className="semibold">{message}</span>
    </Flex>
  );
};

export default NoData;
